import { useState, useEffect } from "react";

const useFetchAllData = (apiCall) => {
    const [data, setData] = useState([]);
    const [response, setResponse] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [refatch, setRefatch] = useState(false);

    const fetchData = async () => {
        if (!apiCall) return;

        setLoading(true);
        setError(null);

        try {
            const res = await apiCall();
            if (res?.data?.success && res.data.data) {
                setResponse(res);
                setData(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch data:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [apiCall, refatch]);

    // just toggle refatch to force re-fetch
    const refetch = () => setRefatch(prev => !prev);

    return { data, response, loading, error, refetch };
};

export default useFetchAllData;
